import { render, staticRenderFns } from "./useSealListDetail.vue?vue&type=template&id=224ac7b6&"
import script from "./useSealListDetail.vue?vue&type=script&lang=js&"
export * from "./useSealListDetail.vue?vue&type=script&lang=js&"
import style0 from "./useSealListDetail.vue?vue&type=style&index=0&id=224ac7b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports